import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const RejectChanges = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path opacity="0.3" d="M3 4.66667L11 4.66667" stroke={color} strokeLinecap="round" />
        <path opacity="0.3" d="M3 7.33333H5.66667" stroke={color} strokeLinecap="round" />
        <path d="M8 7.33333L13.2696 12.6029" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M13.2696 7.33333L8.00002 12.6029" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    )
  },
)

export default RejectChanges
